import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Breadcrumb, message, Spin } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { useMutation, useQuery, gql } from '@apollo/client';
import UserForm from './UserForm';
import { GET_USERS, ADD_USER } from '../../../gql/users';

const GET_ROLES = gql`
  query GET_ROLES($ids: [ID!], $state: State) {
    roles(ids: $ids, state: $state) {
      id
      isDefaultRoleForNewUser
    }
  }
`;

const AddUser = () => {
  const history = useHistory();
  const { data, loading } = useQuery(GET_ROLES, {
    variables: { state: 'ACTIVE' },
  });
  const [addUser, { loading: mutationLoading }] = useMutation(ADD_USER, {
    refetchQueries: [{ query: GET_USERS, variables: { state: 'ALL' } }],
    onCompleted: ({ addUser }) => {
      history.push('/system-setting/users');
      message.success(`${addUser.netId} successfully added`);
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const getDefaultRoles = data?.roles.reduce(
    (acc, { id, isDefaultRoleForNewUser }) => {
      if (isDefaultRoleForNewUser) {
        acc.push({ role: id });
      }
      return acc;
    },
    []
  );
  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Add User',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/users">Users</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Add User</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <Spin spinning={mutationLoading} tip="Adding...">
        <UserForm
          initialValues={{ roles: getDefaultRoles }}
          onFinish={(input) => {
            addUser({
              variables: {
                addUserInput: input,
              },
            });
          }}
        />
      </Spin>
    </PageContainer>
  );
};

export default AddUser;
